
// 购销计划分页查询导出
const download = '/CONTINUTIY-SERVICE/uccommon/execlExport/downloadFile.magpie'
// 购销计划详情页统一导出
const detail = '/CONTINUTIY-SERVICE/ucposition/detailExportExcel/downloadFile.magpie'
// 交易费用、盈亏明细的导出（包含详情）
const exportExcelData = '/CT-REPORT-SERVER/common/exportExcelData/downloadFile.magpie'
// 月报表导出
const monthlyReportExport = '/CONTINUTIY-SERVICE/ucreport/monthlyDataExcel.file'
// 购销计划一览表导出
const purchaseSaleListExport = '/CONTINUTIY-SERVICE/ucreport/salePlanDataExcel.file'
// 电子回单下载
const billExport = '/PAY-FACADE-SERVER/receipt/batchDownload/downloadFile.magpie'

export { download, detail, exportExcelData, monthlyReportExport, purchaseSaleListExport, billExport }
